<div class="dropdown-container">
  <button class="filter-button" [ngClass]="{ 'filters-applied': filtersApplied }" [disabled]="isDisabled" (click)="toggleDropdown()">
    <span>{{ selectedOption }}</span>

    <!-- Show clear button if filters are applied -->
    @if (filtersApplied) {
      <span
        class="clear-icon"
        (click)="clearFilters(); $event.stopPropagation()"
        title="Clear filters"
        >
        <img src="shared-assets/icons/close.png" alt="Clear Filters" class="clear-icon" />
      </span>
    }

    <!-- Show dropdown arrow ONLY when no filters are applied -->
    @if (!filtersApplied) {
      <svg
        class="icon"
        [style.transform]="isOpen ? 'rotate(180deg)' : ''"
        viewBox="0 0 11 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path d="M5.5 6L0 0.5H11L5.5 6Z" fill="#757575" />
      </svg>
    }
  </button>

  @if (isOpen) {
    <div class="dropdown-menu" [class.left]="positionMenu === 'left'">
      @for (option of options; track option) {
        <div class="dropdown-item" (click)="selectOption(option)">
          {{ option }}
          @if (option === selectedOption) {
            <span class="checkmark">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="11" fill="#00C6A9" />
                <path
                  d="M8 12l3 3 6-6"
                  stroke="white"
                  stroke-width="2.5"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  />
              </svg>
            </span>
          }
        </div>
      }
    </div>
  }
</div>
